module.exports = __webpack_public_path__ + "static/media/Group 2167.e9664453.svg";